import React, { createContext, useContext, useState, useEffect } from "react";
import HorseService from "../Services/horseService";

const HorsesContext = createContext();

export const HorsesProvider = ({ children }) => {
  const [horsesData, setHorsesData] = useState([]);
  const [isFetchingHorses, setIsFetchingHorses] = useState(true);

  useEffect(() => {
 

    fetchHorses();
  }, []);

  const fetchHorses = async () => {
    setIsFetchingHorses(true);
    try {
      const fetchHorsesData = await HorseService.GetHorses();
      setHorsesData(fetchHorsesData);
    } catch (error) {
      console.error("Erreur lors du chargement des clients", error);
    } finally {
      setIsFetchingHorses(false);
    }
  };

  const updateHorse = async (id) => {
    const fetchHorseCard = await HorseService.GetHorse(id);
    setHorsesData(
      horsesData.map((horse) =>
        horse.externalId === fetchHorseCard.externalId ? { ...horse, ...fetchHorseCard } : horse
      )
    );
  };

  return (
    <HorsesContext.Provider value={{ horsesData, updateHorse, fetchHorses, isFetchingHorses }}>
      {children}
    </HorsesContext.Provider>
  );
};

export const useHorses = () => useContext(HorsesContext);
